import Api from './ApiService'

export default {
    loginADM(credentials) {
        return Api().post('admins/login', credentials);
    },
}